export enum DirectionHorizontal {
	None	= 0,
	Left 	= 1,
	Right 	= 2
}
export enum DirectionVertical {
	None	= 0,
	Top 	= 1,
	Bottom 	= 2
}